import { render, staticRenderFns } from "./PharmacistRequestedAppointmentsTable.vue?vue&type=template&id=044fce40&scoped=true&"
import script from "./PharmacistRequestedAppointmentsTable.vue?vue&type=script&lang=js&"
export * from "./PharmacistRequestedAppointmentsTable.vue?vue&type=script&lang=js&"
import style0 from "./PharmacistRequestedAppointmentsTable.vue?vue&type=style&index=0&id=044fce40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044fce40",
  null
  
)

export default component.exports